export enum ACPCustomEvents {
  BusinessContextDataUpdated = 'aboveCloud_BusinessContextDataUpdatedEvent',
  ContextHelpPinned = 'aboveCloud_ContextHelpPinned',
  ContextHelpUnpinned = 'aboveCloud_ContextHelpUnpinned',
  PropertyBusinessDateUpdated = 'aboveCloud_PropertyBusinessDateUpdatedEvent',
  PropertyLocalDateTimeUpdated = 'aboveCloud_PropertyBusinessDateTimeUpdatedEvent',
  ContextHelpClosed = 'aboveCloud_ContextHelpClosed',
  CashierStatusOpened = 'aboveCloud_CashierStatusOpened',
}
